'use client';

import type { ErrorInfo, ReactNode } from 'react';
import React, { createContext, useContext } from 'react';

export type ErrorReportingHandler = (
  error: Error,
  errorInfo: ErrorInfo,
  componentName?: string,
) => void;

const ErrorReportingContext = createContext<ErrorReportingHandler | null>(null);

export function ErrorReportingProvider({
  children,
  onError,
}: {
  children: ReactNode;
  onError: ErrorReportingHandler;
}) {
  return (
    <ErrorReportingContext.Provider value={onError}>{children}</ErrorReportingContext.Provider>
  );
}

export function useErrorReporting(): ErrorReportingHandler | null {
  return useContext(ErrorReportingContext);
}

export { ErrorReportingContext };
